module.exports = __webpack_public_path__ + "img/cardapio.154e0d4b.svg";